import request from '../../request';
import router from '../../routes';

let storedUser = {
  first_name: '',
  last_name: '',
  username: '',
  email: '',
  type: '',
};
if (localStorage.getItem('user') !== null) {
  const localUserStr = localStorage.getItem('user');
  if (typeof localUserStr !== 'undefined' && localUserStr !== 'undefined') {
    try {
      storedUser = JSON.parse(localUserStr);
    } catch (e) {
      console.log(e); // eslint-disable-line
    }
  }
}

const UserState = {
  state: {
    data: storedUser,
    gotDataFromServer: false,
    unprocessable: false,
    unauthorized: false,
    unauthorizedStatus: '',
    isUserLoggingIn: false,
    formValid: undefined,
    formSaved: undefined,
    form: {
      firstName: {
        name: 'first_name',
        value: storedUser.first_name,
        label: 'First Name',
        icon: 'fa-id-card-o',
        errors: [],
      },
      lastName: {
        name: 'last_name',
        value: storedUser.last_name,
        label: 'Last Name',
        icon: '',
        errors: [],
      },
      username: {
        name: 'username',
        value: storedUser.username,
        label: 'Last Name',
        icon: '',
        errors: [],
      },
      email: {
        name: 'email',
        value: storedUser.email,
        label: 'Email',
        icon: '',
        errors: [],
      },
      type: {
        name: 'type',
        value: storedUser.type,
        label: 'Type',
        icon: '',
        errors: [],
      },
      emailUsername: {
        name: 'emailUsername',
        value: '',
        label: 'Email or username',
        icon: 'fa-user',
        errors: [],
        autoValidate: false,
      },
      password: {
        name: 'password',
        value: '',
        label: 'Password',
        icon: 'fa-lock',
        errors: [],
        autoValidate: false,
      },
      oldPassword: {
        name: 'old_password',
        value: '',
        label: 'Current Password',
        icon: 'fa-lock',
        errors: [],
        autoValidate: false,
      },
      passwordConfirm: {
        name: 'password_confirm',
        value: '',
        label: 'Confirm Password',
        icon: 'fa-lock',
        errors: [],
        autoValidate: false,
      },
    },
  },
  mutations: {
    setUserFormValidationErrors(state, errors) {
      Object.keys(state.form).forEach((key) => {
        if (typeof errors[state.form[key].name] !== 'undefined') {
          Object.assign(state.form[key], { errors: errors[state.form[key].name] });
        } else {
          Object.assign(state.form[key], { errors: [] });
        }
      });
    },
    setFormSaved(state, status) {
      Object.assign(state, { formSaved: status });
    },
    clearUser(state) {
      Object.assign(state.form.emailUsername, { value: '' });
      Object.assign(state.form.password, { value: '' });
    },
    setUserFormField(state, { field, value }) {
      Object.assign(state.form[field], { value });
    },
  },
  actions: {
    validateUserSettingsForm(context) {
      context.dispatch('updateUser', { validateOnly: true });
    },
    UserResetUserPass(context) {
      context.commit('clearUser');
    },
    setUser(context, user) {
      return new Promise((resolve) => {
        Object.assign(context.state.data, user);
        localStorage.setItem('user', JSON.stringify(user));
        if (typeof user.language !== 'undefined') {
          Object.assign(context.rootState, { language: user.language });
        }
        Object.assign(context.state.data, user);
        Object.assign(context.state.form.firstName, { value: user.first_name });
        Object.assign(context.state.form.lastName, { value: user.last_name });
        Object.assign(context.state.form.email, { value: user.email });
        Object.assign(context.state.form.type, { value: user.type });
        Object.assign(context.state.form.username, { value: user.username });
        Object.assign(context.state.form.emailUsername, { value: user.email });
        Object.assign(context.state.form.password, { value: '' });
        Object.assign(context.state.form.oldPassword, { value: '' });
        Object.assign(context.state.form.passwordConfirm, { value: '' });
        resolve();
      });
    },

    updateUser(context, payload) {
      const sendData = {
        username: context.rootState.user.data.username,
        first_name: context.state.form.firstName.value,
        last_name: context.state.form.lastName.value,
        email: context.state.form.email.value,
      };
      if (context.state.form.oldPassword.value !== '') {
        sendData.old_password = context.state.form.oldPassword.value;
      }
      if (context.state.form.password.value !== '') {
        sendData.password = context.state.form.password.value;
      }
      if (context.state.form.passwordConfirm.value !== '') {
        sendData.passwordConfirm = context.state.form.passwordConfirm.value;
      }

      if (typeof payload !== 'undefined') {
        if (payload.validateOnly) {
          sendData.validateOnly = true;
        }
      }
      request.make({
        type: 'PUT',
        url: `${process.env.API_URL}user`,
        data: sendData,
      }, (err, res) => {
        context.dispatch('setValidationErrors', {
          collection: 'user',
          body: res.body,
        });
        if (res.status === 204) {
          Object.assign(context.state, { formSaved: true });
        } else if (res.status === 422) {
          context.commit('setUserFormValidationErrors', res.body.errors);
          if (payload === 'undefined') {
            Object.assign(context.state, { formSaved: false });
            context.dispatch('showSaveError');
          }
        }
      });
    },
    loginUser(context) {
      Object.assign(context.state, {
        unprocessable: false,
        unauthorized: false,
        isUserLoggingIn: true,
      });
      const URL = `${process.env.API_URL}auth/login`;
      request
      .make({
        type: 'POST',
        url: URL,
        data: {
          emailUsername: context.state.form.emailUsername.value,
          password: context.state.form.password.value,
        },
      }, (err, res) => {
        Object.assign(context.state, { isUserLoggingIn: false });
        if (typeof res !== 'undefined') {
          if (res.status === 200) {
            if (typeof res.body.token !== 'undefined') {
              context.dispatch('setJWT', res.body.token);
              context.dispatch('setUser', res.body.user);
              context.commit('user/set', res.body.user, { root: true });
              if (res.body.user.type === 'user') {
                context.dispatch('client/get', null, { root: true });
              }
              if (typeof res.body.user.language !== 'undefined') {
                context.commit('setLanguage', res.body.user.language);
              }
              context.dispatch('bookingPublic/get', null, { root: true });
              context.dispatch('successLoginRedirect');
            }
            setTimeout(() => {
              context.commit('logout');
            }, 1000 * 60 * 60 * 20);
          } else if (res.status === 401) { // Unauthorized
            Object.assign(context.state, { unauthorized: true });
            Object.assign(context.state, { unauthorizedStatus: res.body.message });
          } else if (res.status === 422) { // Unprocessable. validation errors
            Object.assign(context.state, { unprocessable: true });
          }
        }
      });
    },
    successLoginRedirect(context) {
      if (context.state.data.type === 'promoter') {
        if (context.state.data.has_accepted_terms !== true) {
          router.push(`/${context.rootState.language}/supplier/settings`);
        } else {
          router.push(`/${context.rootState.language}/supplier/dashboard`);
        }
      } else if (context.state.data.type === 'admin') {
        router.push(`/${context.rootState.language}/admin/dashboard`);
      } else if (typeof context.rootState.previousUrl !== 'undefined') {
        router.push(context.rootState.previousUrl);
      } else {
        router.push(`/${context.rootState.language}/`);
      }
    },
    resetFormSaved(context) {
      context.commit('setFormSaved', undefined);
    },
  },
  getters: {},
};


export default UserState;



// WEBPACK FOOTER //
// ./src/store/promoter/userDeprecated.js